if (!window.__mtScriptsInit) {
  window.__mtScriptsInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initContador();
    initMarquesina();
    initGaleriaProducto();
    initVariantesProducto();
    initBundleSelector();
    initComparador();
    initFAQ();
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initContador() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
        var sufijo = el.getAttribute('data-mt-sufijo') || '';
        obs.unobserve(el);
        if (reduce) { el.textContent = fin + sufijo; return; }
        var inicio = 0;
        var duracion = 1400;
        var t0 = null;
        function paso(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / duracion, 1);
          var val = inicio + (fin - inicio) * (1 - Math.pow(1 - p, 3));
          el.textContent = (Number.isInteger(fin) ? Math.round(val) : val.toFixed(1)) + sufijo;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.5 }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquesina() {
  document.querySelectorAll('[data-mt-marquesina]').forEach(function (wrap) {
    var track = wrap.querySelector('.mt-marquee-track');
    if (!track || track.dataset.mtClonado) return;
    track.dataset.mtClonado = '1';
    track.innerHTML += track.innerHTML;
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-galeria-principal]');
  var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      var alt = mini.getAttribute('data-alt') || '';
      if (!full) return;
      principal.style.opacity = '0';
      window.setTimeout(function () {
        principal.src = full;
        principal.alt = alt;
        principal.style.opacity = '1';
      }, 150);
      minis.forEach(function (m) { m.classList.remove('mt-mini-activa'); });
      mini.classList.add('mt-mini-activa');
    });
  });
}

function initBundleSelector() {
  document.querySelectorAll('[data-mt-bundle]').forEach(function (bundle) {
    var tiers = bundle.querySelectorAll('[data-mt-tier]');
    var scope = bundle.closest('[data-mt-producto-form]') || bundle.parentElement;
    var infoScope = bundle.closest('.mt-producto-info') || document;
    var qtyInput = scope ? scope.querySelector('[data-mt-bundle-qty]') : null;
    var submitBtn = scope ? scope.querySelector('.product-form__submit') : null;
    var buy3Link = scope ? scope.querySelector('[data-mt-bundle-buy3]') : null;
    var precioEl = infoScope.querySelector('[data-mt-precio]');
    var comparadoEl = infoScope.querySelector('[data-mt-precio-comparado]');
    var ahorroEl = infoScope.querySelector('[data-mt-precio-ahorro]');
    var variantId = bundle.getAttribute('data-variant-id');
    var tier3Code = bundle.getAttribute('data-tier3-code');

    function seleccionar(tier) {
      tiers.forEach(function (t) {
        var activa = t === tier;
        t.classList.toggle('mt-tier-activa', activa);
        t.setAttribute('aria-pressed', activa ? 'true' : 'false');
      });
      var qty = tier.getAttribute('data-qty');
      if (qtyInput) qtyInput.value = qty;

      var precioFinal = tier.getAttribute('data-precio-final');
      var precioTachado = tier.getAttribute('data-precio-tachado');
      var ahorro = tier.getAttribute('data-ahorro');
      if (precioEl && precioFinal) precioEl.textContent = precioFinal;
      if (comparadoEl) {
        if (precioTachado) {
          comparadoEl.textContent = precioTachado;
          comparadoEl.style.display = '';
        } else {
          comparadoEl.style.display = 'none';
        }
      }
      if (ahorroEl) {
        if (ahorro) {
          ahorroEl.textContent = ahorro;
          ahorroEl.style.display = '';
        } else {
          ahorroEl.style.display = 'none';
        }
      }

      if (qty === '3') {
        if (submitBtn) submitBtn.style.display = 'none';
        if (buy3Link) {
          var redirect = '/cart/' + variantId + ':3';
          buy3Link.href = '/discount/' + encodeURIComponent(tier3Code) + '?redirect=' + encodeURIComponent(redirect);
          buy3Link.style.display = '';
        }
      } else {
        if (submitBtn) submitBtn.style.display = '';
        if (buy3Link) buy3Link.style.display = 'none';
      }
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () { seleccionar(tier); });
    });

    var preseleccionada = bundle.querySelector('.mt-tier-activa') || tiers[0];
    if (preseleccionada) seleccionar(preseleccionada);
  });
}

function initComparador() {
  document.querySelectorAll('[data-mt-comparador]').forEach(function (comp) {
    var antes = comp.querySelector('[data-mt-comp-antes]');
    var antesImg = comp.querySelector('[data-mt-comp-antes-img]');
    var handle = comp.querySelector('[data-mt-comp-handle]');
    if (!antes || !antesImg || !handle) return;

    function ajustarAncho() {
      antesImg.style.width = comp.offsetWidth + 'px';
    }
    ajustarAncho();
    window.addEventListener('resize', ajustarAncho);

    function mover(clientX) {
      var rect = comp.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      antes.style.width = pct + '%';
      handle.style.left = pct + '%';
    }

    var arrastrando = false;
    comp.addEventListener('pointerdown', function (e) {
      arrastrando = true;
      if (comp.setPointerCapture) comp.setPointerCapture(e.pointerId);
      mover(e.clientX);
    });
    comp.addEventListener('pointermove', function (e) {
      if (arrastrando) mover(e.clientX);
    });
    comp.addEventListener('pointerup', function () { arrastrando = false; });
    comp.addEventListener('pointerleave', function () { arrastrando = false; });
  });
}

function initFAQ() {
  document.querySelectorAll('[data-mt-faq-item]').forEach(function (item) {
    var btn = item.querySelector('[data-mt-faq-btn]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-faq-abierto');
      item.classList.toggle('mt-faq-abierto', !abierto);
      btn.setAttribute('aria-expanded', abierto ? 'false' : 'true');
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-mt-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-mt-opcion]');
    var idInput = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var comparadoEl = form.querySelector('[data-mt-precio-comparado]');
    var botonEl = form.querySelector('[data-mt-boton-comprar]');
    if (!selects.length || !idInput) return;

    function moneda(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      });
    }

    function actualizar() {
      var seleccion = Array.from(selects).map(function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === seleccion[i]; });
      });
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = moneda(variante.price);
      if (comparadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          comparadoEl.textContent = moneda(variante.compare_at_price);
          comparadoEl.style.display = '';
        } else {
          comparadoEl.style.display = 'none';
        }
      }
      if (botonEl) {
        botonEl.disabled = !variante.available;
        botonEl.textContent = variante.available
          ? botonEl.getAttribute('data-texto-disponible')
          : botonEl.getAttribute('data-texto-agotado');
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}
